"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var jsx_runtime_1 = require("react/jsx-runtime");

var supportLink = 'https://wwwpwcnetwork.pwc.myshn.net/hub?id=sc_cat_item&sys_id=ff2977811b357010bdec7bb5464bcb0f';

var SupportTicketLink = function () {
  return (0, jsx_runtime_1.jsx)("a", __assign({
    href: supportLink,
    target: "_blank",
    rel: "noopener noreferrer",
    className: "external-source-link"
  }, {
    children: "create a support ticket here"
  }), void 0);
};

exports.default = SupportTicketLink;